import { render, staticRenderFns } from "./SaleDetail.vue?vue&type=template&id=4f858cbe&scoped=true&"
import script from "./SaleDetail.vue?vue&type=script&lang=js&"
export * from "./SaleDetail.vue?vue&type=script&lang=js&"
import style0 from "./SaleDetail.vue?vue&type=style&index=0&id=4f858cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f858cbe",
  null
  
)

export default component.exports